export default "__VITE_ASSET__ClyAacGu__"